/**
 * User search form utilities.
 * Handles URL parameter parsing and filter normalization for the Users page.
 */

/**
 * Find a role object in roleOptions by its numeric value.
 *
 * @param {Array} roleOptions - Array of role option objects { value, label }
 * @param {string|number} value - The role value to find
 * @returns {Object|undefined} The matching role object or undefined
 */
export function findRoleByValue(roleOptions, value) {
    if (!Array.isArray(roleOptions)) return undefined;
    return roleOptions.find((r) => r.value === Number(value));
}

/**
 * Clean and normalize the user filter object for URL params.
 * Role is a single { value, label } (legacy: array of one item is still supported).
 *
 * @param {Object} filter - The filter form object
 * @param {Array} userRange - Pagination range
 * @param {Array} userSort - Sort configuration
 * @returns {Object} Cleaned filter object with range and sort
 */
export function cleanUserFilter(filter, userRange, userSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => {
                if (k === 'role' && v) {
                    if (Array.isArray(v) && v.length > 0) {
                        const first = v[0];
                        return [k, first?.value ?? first?.id ?? ''];
                    }
                    if (typeof v === 'object') {
                        return [k, v.value ?? v.id ?? ''];
                    }
                }
                return [k, v];
            })
            .filter(([_, v]) => v != null && v !== ''),
    );
    filtered.userRange = userRange;
    filtered.userSort = userSort;
    return filtered;
}
